<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">{{pageTitle}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
  <form [formGroup]="userDetails" autocomplete="off">

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">First Name</label>
        <input class="form-control" placeholder="First Name" formControlName="firstName"
              [class.is-invalid]="userDetails.controls['firstName'].invalid && userDetails.controls['firstName'].touched">
        <div class="invalid-feedback">First name is required.</div>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Last Name</label>
        <input class="form-control" placeholder="Last Name" formControlName="lastName"
              [class.is-invalid]="userDetails.controls['lastName'].invalid && userDetails.controls['lastName'].touched">
        <div class="invalid-feedback">Last name is required.</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Email Address</label>
        <input class="form-control" placeholder="Email Address" formControlName="emailAddress"
              [class.is-invalid]="userDetails.controls['emailAddress'].invalid && userDetails.controls['emailAddress'].touched">
        <div class="invalid-feedback">
          <span *ngIf="userDetails.controls['emailAddress'].hasError('required')">Email address is required.</span>
          <span *ngIf="userDetails.controls['emailAddress'].hasError('email')">Please enter a valid email address.</span>
        </div>
      </div>
      <div class="col-sm-6" [hidden]="internalUser || companyGroupId">
        <label class="form-label fw-semibold">Company Group</label>
        <select class="form-select" formControlName="companyGroupId">
          <option [ngValue]="null"></option>
          <option *ngFor="let group of companyGroups" [ngValue]="group.id">{{group.name}}</option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Role</label>
        <select class="form-select" formControlName="role" (change)="updateTeamLeaders()"
                [class.is-invalid]="userDetails.controls['role'].invalid && userDetails.controls['role'].touched">
          <option [ngValue]="null"></option>
          <option *ngFor="let role of roles" [ngValue]="role.roleID">{{role.roleName}}</option>
        </select>
        <div class="invalid-feedback">Role is required.</div>
      </div>
    </div>

    <ng-container *ngIf="internalUser && userDetails.controls['role'].value != 6">

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Are they a Team Leader?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="isTeamLeader"></app-yes-no-form-toggle>
        </div>
        <div class="col-sm-6" [hidden]="userDetails.controls['isTeamLeader'].value == 1">
          <label class="form-label fw-semibold">Select their Team Leader</label>
          <select class="form-select" formControlName="teamLeaderUserId">
            <option [ngValue]="null"></option>
            <option *ngFor="let teamLeader of teamLeaders" [ngValue]="teamLeader.id">
              {{teamLeader.firstName}} {{teamLeader.lastName}}
            </option>
          </select>
        </div>
      </div>

      <ng-container *ngIf="userDetails.controls['role'].value == 5 && userDetails.controls['isTeamLeader'].value == 1">
        <div class="row mb-3">
          <div class="col-sm-4">
            <label class="form-label fw-semibold">Can Allocate Cases?</label>
            <app-yes-no-form-toggle class="d-block" formControlName="canAllocateCases"></app-yes-no-form-toggle>
          </div>
          <div class="col-sm-4">
            <label class="form-label fw-semibold">Can Reallocate Cases?</label>
            <app-yes-no-form-toggle class="d-block" formControlName="canReallocateCases"></app-yes-no-form-toggle>
          </div>
          <div class="col-sm-4">
            <label class="form-label fw-semibold">Can See Admin Actions?</label>
            <app-yes-no-form-toggle class="d-block" formControlName="canSeeAdminActions"></app-yes-no-form-toggle>
          </div>
        </div>
      </ng-container>

    </ng-container>

    <ng-container *ngIf="internalUser">

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Are they an AML Officer?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="isAMLOfficer"></app-yes-no-form-toggle>
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Position</label>
          <input class="form-control" placeholder="Position" maxlength="50" formControlName="position">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Klyant Client ID</label>
          <input class="form-control" type="number" placeholder="Client ID" formControlName="klyantApiClientId">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Klyant API Secret</label>
          <input class="form-control" placeholder="API Secret" formControlName="klyantApiSecret">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Initial Colour on Case Timeline</label>
          <input type="color" class="form-control form-control-color" [formControl]="colorCtr">
        </div>
      </div>

    </ng-container>

    <ng-container *ngIf="!internalUser">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Has API Access</label>
          <app-yes-no-form-toggle class="d-block" formControlName="hasAPIAccess"></app-yes-no-form-toggle>
        </div>
        <div class="col-sm-6" [hidden]="userDetails.controls['hasAPIAccess'].value != 1">
          <label class="form-label fw-semibold">Application Key</label>
          <input class="form-control" placeholder="Key" maxlength="250" formControlName="applicationKey">
        </div>
      </div>
    </ng-container>

    <div class="row mb-3"  *ngIf="!newUser">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Account Disabled</label>
        <app-yes-no-form-toggle class="d-block" formControlName="accountDisabled"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6" *ngIf="!newUser">
        <label class="form-label fw-semibold">Last Login</label>
        <div class="form-control-plaintext text-muted">{{lastLoginTime}}</div>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">

  <ng-container *ngIf="!newUser">
    <button *ngIf="!sendingPasswordReset && !updating" type="button" class="btn btn-success" (click)="resetPassword()" [disabled]="userDetails.invalid">
      Reset Password
    </button>
    <button *ngIf="sendingPasswordReset" type="button" class="btn btn-outline-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Sending Password Reset Email ...
    </button>
    <button type="button" *ngIf="!updating && !sendingPasswordReset" class="btn btn-success" (click)="saveUser()" [disabled]="userDetails.invalid">Update</button>
    <button *ngIf="updating" type="button" class="btn btn-outline-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Saving ...
    </button>
  </ng-container>

  <ng-container *ngIf="newUser">
    <button *ngIf="!sendingInvitation" type="button" class="btn btn-success" (click)="addUser()" [disabled]="userDetails.invalid">
      Send Email Invitation <fa-icon [icon]="faEnvelope"></fa-icon>
    </button>
    <button *ngIf="sendingInvitation" type="button" class="btn btn-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Adding & Sending Email Invitation...
    </button>
  </ng-container>

</div>